import { useEffect } from "react";
import './language-switcher.css'
export default function LanguageSwitcher() {
    useEffect(() => {
        // Config cho widget
        window.gtranslateSettings = window.gtranslateSettings || {};
        window.gtranslateSettings["43217984"] = {
            default_language: "en",
            languages: ["af", "sq","am","en","fa","ar", "ps", "ja", "zh-CN", "hy", "az", "eu", "be", "bn", "bs", "bg", "ca", "ceb", "ny", "zh-TW", "co",
                "hr", "cs", "da", "nl", "eo", "et", "tl", "fi", "fr", "fy", "gl", "ka", "de", "el", "gu", "ht", "ha", "haw", "iw", "hi", "hmn", "hu", "is",
                "ig","id","ga","it","jw","kn","kk","km","ko","ku","ky","lo","la","lv","lt","lb","mk","mg","ms","ml","mt","mi","mr","mn",
                "my", "ne", "no", "pl", "pt", "pa", "ro", "ru", "sm", "gd", "sr", "st", "sn", "sd", "si", "sk", "sl", "so", "es", "su", "sw", "sv", "tg",
                "ta", "te", "th", "tr", "uk", "ur", "uz", "vi", "cy", "xh", "yi", "yo", "zu"],
            wrapper_selector: ".gt-mordadam-43217984",
            native_language_names: 1,
            flag_style: "2d",
            flag_size: 24,
            horizontal_position: "inline",
            flags_location: "/google-translate-plugin/flags/"
        };
        setTimeout(()=>{
            if (!document.querySelector("script[data-gt-widget-id='43217984']")) {
                const script = document.createElement("script");
                script.src = "/google-translate-plugin/js/gt.min.js";
                script.setAttribute("data-gt-widget-id", "43217984");
                document.body.appendChild(script);

                // Simulate hover to force GTranslate to load the translation library immediately
                // This fixes the issue on mobile where hover doesn't exist
                setTimeout(() => {
                    const wrapper = document.querySelector(".gt-mordadam-43217984");
                    if (wrapper) {
                        wrapper.dispatchEvent(new Event("pointerenter"));
                    }
                }, 500);
            }
        }, 10)

        return () => {
            const script = document.querySelector("script[data-gt-widget-id='43217984']");
            if (script) {
                document.body.removeChild(script);
            }
        };
    }, []);

    return <div className="gt-mordadam-43217984"></div>;
}